import { rem } from "@mantine/core";

interface TimerIconProps extends React.ComponentPropsWithoutRef<"svg"> {
  size?: number | string;
  style?: any;
}

export function TimerIcon({ size, style, ...others }: TimerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 225 225"
      fill="none"
      stroke="currentColor"
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
    >
      <path
        id="Selection"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        d="M 53.00,15.51
           C 49.60,15.89 46.29,16.07 43.00,17.04
             26.00,22.04 14.29,38.13 15.51,56.00
             15.88,61.42 17.23,68.25 19.90,73.00
             20.92,74.80 22.72,77.80 25.09,77.80
             27.23,77.80 29.55,75.35 31.00,73.98
             31.00,73.98 44.00,61.00 44.00,61.00
             44.00,61.00 69.00,36.00 69.00,36.00
             71.14,33.86 77.80,28.02 77.80,25.09
             77.80,22.72 74.80,20.92 73.00,19.90
             67.47,16.79 59.30,15.39 53.00,15.51 Z
           M 162.00,16.47
           C 158.36,17.32 147.20,20.46 147.20,25.09
             147.20,28.02 153.86,33.86 156.00,36.00
             156.00,36.00 183.00,63.00 183.00,63.00
             183.00,63.00 195.00,74.94 195.00,74.94
             196.54,76.32 198.53,78.32 200.82,77.66
             203.38,76.93 205.44,72.29 206.37,70.00
             209.64,62.01 210.03,50.27 207.56,42.00
             201.35,21.24 181.95,13.68 162.00,16.47 Z
           M 53.00,176.00
           C 49.54,179.46 40.24,187.93 38.74,192.00
             36.40,198.37 41.63,203.60 48.00,201.26
             53.76,199.14 60.48,187.44 66.00,188.59
             66.00,188.59 83.00,196.80 83.00,196.80
             93.29,200.84 103.05,202.02 114.00,202.00
             124.66,201.98 135.20,199.76 145.00,195.57
             145.00,195.57 159.00,188.59 159.00,188.59
             166.23,187.09 173.98,206.75 183.77,200.82
             193.83,194.74 177.65,180.67 172.00,178.00
             172.00,178.00 180.23,167.00 180.23,167.00
             188.55,155.11 192.75,142.33 194.07,128.00
             194.07,128.00 194.92,120.00 194.92,120.00
             194.92,108.26 191.54,94.56 186.52,84.00
             180.55,71.47 171.36,60.68 160.00,52.72
             126.49,29.26 80.00,34.04 52.09,64.00
             30.38,87.30 24.55,121.58 36.20,151.00
             39.72,159.89 45.40,170.07 53.00,176.00 Z"
      />
    </svg>
  );
}
